import React from 'react';
import { Button } from '@mui/material';
import { ButtonPropsVariantOverrides } from '@mui/material';
import { OverridableStringUnion } from '@mui/types';

import { PlusIcon } from '@assets/icons';

const AddButton = ({
  label,
  handleButtonClick,
  customStyle,
  customIcon,
  customVariantStyle,
  isDisabled = false
}: {
  label: string;
  handleButtonClick: () => void;
  customStyle?: React.CSSProperties;
  customIcon?: React.ReactNode;
  customVariantStyle?: OverridableStringUnion<
    'text' | 'outlined' | 'contained',
    ButtonPropsVariantOverrides
  >;
  isDisabled?: boolean;
}) => {
  return (
    <div className="group">
      <Button
        variant={customVariantStyle ? customVariantStyle : 'outlined'}
        color="info"
        size="small"
        style={customStyle}
        disabled={isDisabled}
        className=" group-hover:text-white group-hover:bg-brightBlue"
        startIcon={customIcon ? customIcon : <PlusIcon />}
        onClick={handleButtonClick}>
        {label}
      </Button>
    </div>
  );
};

export default AddButton;
